/* eslint-disable no-useless-constructor */
import { AxiosInstance } from 'axios'

export class Base {
  constructor(protected axios: AxiosInstance) {}
}
